export default __webpack_public_path__ + "static/media/75.1617eb5a.jpg";